module.exports = __webpack_public_path__ + "static/media/crumb_icon.ac325a07.svg";